export const MESSAGE_STATUS = {
  STREAMING: "streaming",
  DONE: "done",
  ERROR: "error",
};

export const STREAM_EVENT_TYPES = {
  START: "start",
  THINKING: "thinking",
  PLAN: "plan",
  TOOL_CALL: "tool_call",
  TOOL_RESULT: "tool_result",
  DELTA: "delta",
  CONTEXT: "context",
  SOURCES: "sources",
  FILE_EXPORT: "file_export",
  DASHBOARD_PATCH: "dashboard_patch",
  WARNING: "warning",
  DONE: "done",
  ERROR: "error",
};

export const REQUEST_PHASE = {
  IDLE: "idle",
  CAPTURING: "capturing",
  SENDING: "sending",
  STREAMING: "streaming",
};
